var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1017 43L26.6013 37.5397V30.2594C26.6013 26.0592 27.4413 22.139 29.1214 18.4989C30.8948 14.8587 33.1816 11.5452 35.9817 8.55838C38.7818 5.57157 41.8153 2.91145 45.0821 0.578003C45.8288 1.04469 46.4822 1.60472 47.0422 2.25809C47.6022 2.81811 48.0689 3.56481 48.4423 4.49819C45.8288 6.83163 43.4954 9.25841 41.442 11.7785C39.4819 14.2986 37.9885 17.0054 36.9617 19.8989L47.6022 25.2192V37.5397L37.1017 43ZM10.5005 43L0 37.5397V30.2594C0 26.0592 0.84004 22.139 2.52012 18.4989C4.29354 14.8587 6.58031 11.5452 9.38044 8.55838C12.1806 5.57157 15.2141 2.91145 18.4809 0.578003C19.2276 1.04469 19.8809 1.60472 20.441 2.25809C21.001 2.81811 21.4677 3.56481 21.841 4.49819C19.2276 6.83163 16.8941 9.25841 14.8407 11.7785C12.8806 14.2986 11.3872 17.0054 10.3605 19.8989L21.001 25.2192V37.5397L10.5005 43Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuote);
export default __webpack_public_path__ + "static/media/left-quote.1981b2da7e0f8c5f0ff9c85a393df1b4.svg";
export { ForwardRef as ReactComponent };